const translations = {
  subtitle: "You'll get an email when your resource is published.",
  title: "We're working to lighten your load"
};

export default translations;
